import Vue from 'vue';
import Router from 'vue-router';
import Configurator from '@/components/Configurator';
import DesignReport from '@/components/designReport/DesignReport';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'configurator',
      component: Configurator,
    },
    {
      path: '/design-report',
      name: 'design-report',
      component: DesignReport,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js